// extracted by mini-css-extract-plugin
export var csatScore = "_eh-5";
export var header = "_eh-1";
export var panelWrapper = "_eh-2";
export var postPreview = "_eh-3";
export var rightContent = "_eh-0";
export var wrappingText = "_eh-4";